import React from "react"
import TopTitle from "@components/TopTitle"
import Wrapper from "@components/Wrapper"
import styles from "./SectionOne.module.scss"
import ArticleGraphic from "./SectionOne.png";


export default class SectionOne extends React.Component {

    render() {
        return (
            <section className="container-fluid bg-xl-light-gray">
                <div className="row ml-0 mr-0">
                    <Wrapper className={"w-100 text-left"} gap="outer">
                        <div className="row bg-white justify-content-center pt-10">
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <h3
                                className={
                                    styles.title +
                                    " proxima-nova--extra-bold text-secondary fs-30pt fs-lg-42pt pb-10"
                                }
                                >
                                    Load All Your Apps From One Screen? Yes, It’s Possible!
                                </h3>
                                <div className={styles.contactRow + " row bg-white"}>
                                    <div className={ styles.topTextBody + " col-12"}>
                                        <img alt="EngineID App Launch" className={styles.tabletImage} src={ArticleGraphic} />
                                        <p>
                                            In the professional world, there is nothing better than having what you need at your fingertips. In the past, that meant a well-stocked stationery cabinet, but in 
                                            the digital age it’s getting access to all your apps from one place.
                                        </p>
                                        <p>
                                            When you have many different applications and systems in your organization, it becomes difficult for staff to know how to locate and launch the tools they need to do 
                                            their job. On top of this, asking people to log in to applications or systems each time they load them becomes a dangerous combination of security risk and annoyance.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </section>
        );
    }
}